<template>
  <div class="lad-avatar">
    <div
      class="el-avatar el-avatar--circle"
      :class="[`el-avatar--size-${size}`, svgClass]"
    >
      <LadImage :src="src" :srcset="srcSet" class="image--cover" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'LadAvatar',
  components: {
    LadImage: () =>
      import(
        /* webpackChunkName: "lad-image" */ '@/components/frontends/Image/index'
      ),
  },
  props: {
    src: { type: String, default: '' },
    srcSet: { type: String, default: '' },
    size: { type: Number, default: 60 },
  },
  computed: {
    svgClass() {
      return this.src.endsWith('.svg') ? 'el-avatar--svg' : ''
    },
  },
}
</script>

<style lang="scss">
.lad-avatar {
  display: inline-block;

  .el-avatar {
    display: flex;
    align-items: center;
    justify-content: center;

    $sizes: 20, 30, 40, 50, 60, 70, 80, 90, 100, 130, 140, 150;

    @each $size in $sizes {
      &.el-avatar--size-#{$size} {
        width: #{$size}px;
        height: #{$size}px;
        line-height: #{$size}px;

        img {
          height: 100% !important;
        }
      }
    }

    &--svg {
      display: block !important;

      picture {
        img {
          object-fit: contain;
        }
      }
    }
  }
}
</style>
